import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export const useMediaExplorerCustomerIdEffect = () => {
  const navigate = useNavigate();
  const { customerId, '*': folderPath } = useParams();
  const customerIdRef = useRef<string>();

  useEffect(() => {
    const isCustomerChanged = customerIdRef.current && customerIdRef.current !== customerId;
    if (isCustomerChanged && folderPath !== '') {
      navigate('.', { replace: true });
    }
    customerIdRef.current = customerId;
  }, [customerId, folderPath, navigate]);
};
